import Quill from 'quill';

import { modules } from '.';

modules.forEach((ModuleClass) => {
  Quill.register(
    {
      [`modules/${ModuleClass.moduleName}`]: ModuleClass,
    },
    true,
  );
});
